module.exports = __webpack_public_path__ + "img/21Arthur.1f884491.png";